import React from 'react';
import AdobePluginInstallInstructions from './adobe-plugin';

export default function PremiereProInstallInstructions() {
  return (
    <AdobePluginInstallInstructions
      productName="Adobe Premiere Pro"
      ccxHref="/cc-plugins/premiere-pro.ccx"
      downloadFileName="StreamWork Premiere Pro Plugin.ccx"
      openMenuPath={<strong>Window &gt; UXP Plugins &gt; StreamWork</strong>}
    />
  );
}
